import { kebabCase } from 'change-case';
import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { FALLBACK_NAVIGATION_ICON, isLucideIcon } from '../../lucide-icons';
export const createNavigationStmtInstruction = `
#### Define Navigation Item
Create a navigation item, optionally including an icon and allowing for nested child items.

- syntax: \`create navigation "<label>" [to <viewName>] [with icon <icon>];\`
- example: \`create navigation "Products" to ProductList;\`
- example with icon: \`create navigation "Dashboard" to DashboardView with icon dashboard-icon;\`
- example without link: \`create navigation "Catalog";\`
- example without link with icon: \`create navigation "Catalog" with icon catalog-icon;\`

#### Define Child Navigation Item
Define a child item under a parent navigation item for a structured, nested navigation.

- syntax: \`create navigation "<parentLabel>"->"<label>" [to <viewName>] [with icon <icon>];\`
- example: \`create navigation "Catalog"->"Products" to ProductList with icon product-icon;\`
`;
export const stmtCreateNavigation = ({ label, viewName, icon }) => {
    return `create navigation "${label.replaceAll(/"/g, '')}"${viewName ? ` to ${viewName}` : ''}${icon ? ` with icon ${icon}` : ''};`;
};
export const createNavigationHandler = createStructureStatementHandler({
    type: 'create navigation',
    parse: line => {
        const match = /^create navigation (?<label>["]+\w.+["]+(?:->"\w.+")*)(?: to (?<viewName>\w+))?(?: with icon (?<icon>[\w-_]+))?/.exec(line);
        return match?.groups
            ? {
                type: 'create navigation',
                label: match.groups.label,
                viewName: match.groups.viewName,
                icon: match.groups.icon === undefined ? undefined : isLucideIcon(match.groups.icon) ? kebabCase(match.groups.icon) : FALLBACK_NAVIGATION_ICON,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.addNavigationItem({
                label: stmt.label,
                viewName: stmt.viewName,
                icon: stmt.icon,
            });
        });
    },
});
//# sourceMappingURL=CreateNavigationStmt.js.map